// import Swiper from 'swiper/bundle';
import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, Thumbs } from 'swiper/core';

SwiperCore.use([Navigation, Pagination, Thumbs]);

var swiper = new Swiper(".car-thumbs", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
});

var swiper2 = new Swiper(".car-main-gallery", {
    spaceBetween: 10,
    autoHeight: true,
    navigation: {
        nextEl: ".swiper-next",
        prevEl: ".swiper-prev",
    },
    thumbs: {
        swiper: swiper,
    },
});
